const $ = require("jquery");
import Chart from 'chart.js/auto';

(function () {
    var $reviewElement = $('[data-reviews]');

    if ($reviewElement) {
        var reviewIds = $reviewElement.data('reviews');
        var reviewsLocation = $reviewElement.data('reviews-location');
        var shouldHideAvarage = $reviewElement.data('should-hide-avarage-grade');

        if (!reviewIds) {
            return;
        }

        $reviewElement.append('<div class="c-spinner"></div>')

        $.ajax({
            cache: false,
            type: "POST",
            url: "/reviews/GetReviews/",
            data: {
                "reviewIds": reviewIds,
                "location": reviewsLocation,
                "shouldHideAvarage": shouldHideAvarage,
            },
            success: function (data) {
                $reviewElement.html(data);

                InitializeAverageRating();
                InitializeReviewerRating();
                InitializeShowMoreContent();
                InitializeShowMoreReviews();
            }
        });
    }

    function InitializeAverageRating() {
        var $ratedElement = $('[data-google-rating]');

        if (!$ratedElement.length) {
            return;
        }

        var value = $ratedElement.data('google-rating').toString();

        var valueDecimal;

        if (value.includes(',') || value.indexOf('.')) {
            valueDecimal = value.replace(",", ".");
        }

        var options = {
            max_value: 5,
            initial_value: valueDecimal,
            readonly: true
        }

        $ratedElement.rate(options);
    }
    function InitializeReviewerRating() {
        var $ratingElement = $('[data-reviewer-rating]');

        if (!$ratingElement) {
            return;
        }

        $ratingElement.each((i, current) => {

            var value = current.getAttribute('data-reviewer-rating');

            var options = {
                max_value: 5,
                initial_value: value,
                readonly: true
            }

            $(current).rate(options);
        })
    }
    function InitializeShowMoreContent() {
        var $content = $('[data-show-more]');

        if (!$content) {
            return;
        }

        $content.each(function (i, element) {
            $(element).showMore({
                minheight: 25,
                buttontxtmore: "Läs mer",
                buttontxtless: "Stäng",
                buttoncss: "c-google-reviews__item__comment__show-more"
            });
        });
    }
    function InitializeShowMoreReviews() {
        let $toggler = $('[data-show-more-reviews]'),
            $list = $('[data-show-more-reviews-list]');

        $toggler.on('click', function () {

            $list.toggleClass('active');

            if ($list.hasClass('active')) {
                $list.slideDown();

                $('html, body').animate({
                    scrollTop: $list.offset().top
                }, 300);

                $toggler.text('Visa färre recensioner');

                InitializeShowMoreContent();
            }
            else {
                $list.slideUp();

                $('html, body').animate({
                    scrollTop: $('.c-google-reviews').offset().top
                }, 300);

                $toggler.text('Visa fler recensioner');
            }
        });
    }
})();